import TopNavbar from "./TopNavbar";
import '../assets/css/style.css';
import { Helmet } from "react-helmet-async";
import Footer from "./Footer";
import Card from './BlogCard'; // Adjust the path if needed
import blog1Img from "../assets/images/dsa_patterns_that_every_developer_should_know_easy_data_structures.jpg";
import blog2Img from "../assets/images/why_data_structures_and_algorithms_are_important_for_interviews_easy_data_structures.jpg";


export default function Blog() {
    return (
        <>
        <Helmet>
            <title>Blog - Easy Data Structures</title>
            <meta name="description" content="Learn data structures with ease on Easy Data Structures. Explore beginner-friendly tutorials, coding guides, and helpful resources for mastering DSA concepts." />
            <link rel="canonical" href="https://easydatastructures.com/blog" />
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/",
            "logo": "https://easydatastructures.com/easyDS-easydatastructures-logo.webp",
            "sameAs": [
                "https://www.facebook.com/EasyDataStructures",
                "https://www.instagram.com/easydatastructures",
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "Person",
            "name": "Madan Lal",
            "url": "https://madanlal1.github.io/Profile-Portfolio/",
            "image": "https://avatars.githubusercontent.com/u/81483460?v=4",
            "sameAs": [
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]  
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/blog/"
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What is Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Easy Data Structures is an online platform that provides simple explanations, visuals, tutorials, and real-world examples of data structures and algorithms to help students and developers learn quickly."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Who can learn from Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The website is designed for beginners, computer science students, job seekers preparing for technical interviews, and developers who want to refresh their knowledge of data structures."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Are the tutorials suitable for coding interview preparation?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, the tutorials and examples on Easy Data Structures cover the core concepts frequently asked in technical interviews, including arrays, linked lists, stacks, queues, trees, graphs, and algorithms."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Is Easy Data Structures free to use?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, all the explanations and learning material on Easy Data Structures are freely available for students and developers."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Which data structures can I learn on this website?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can learn core data structures such as arrays, linked lists, stacks, queues, trees, heaps, hash tables, graphs, and more, along with visual examples and use cases."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Does Easy Data Structures offer real-world examples?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, each topic includes simple, real-world examples to help you understand how data structures are used in actual applications."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can beginners understand the explanations easily?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely. The content is written in simple language with diagrams and step-by-step explanations, making it ideal for beginners."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Do I need coding experience to start?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No prior coding experience is required. The website starts with the basics and gradually introduces you to more advanced concepts."
                    }
                }
                ]
            }
            )}
            </script>
        </Helmet>
        <TopNavbar/>
        <div className="blog-container container">
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-4">
                    <Card
                        title="DSA Patterns That Every Developer Should Know"
                        image={blog1Img}
                        description="A beginner-friendly guide to understanding data structures and algorithms."
                        link="/DSA-patterns-every-developer-should-know"
                    />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4">
                    <Card
                        title="Why Data Structures and Algorithms Are Important for Interviews"
                        image={blog2Img}
                        description="Learn why Data Structures and Algorithms are essential for cracking technical interviews and becoming a strong problem-solving developer."
                        link="/Why-data-structures-and-algorithms-are-Important-for-interviews"
                    />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4">
                    
                </div>
            </div>
        </div>
        <Footer/>
        </>
    )
}